import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ShowdownDirective } from '../../../directives/animations/showdown.directive';
import { ShowleftDirective } from '../../../directives/animations/showleft.directive';

@Component({
  selector: 'section[app-about-believe-section]',
  imports: [MatIconModule, ShowleftDirective, ShowdownDirective],
  templateUrl: './about-believe-section.html',
  styleUrl: './about-believe-section.scss',
})
export class AboutBelieveSection {

}
